// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"200":"wix-i18n-config_intl-pluralrules","894":"wix-i18n-config_intl-relativetimeformat","994":"EditorPlatformSDK2.0"}[chunkId] || chunkId) + ".chunk.min.js";
};